import { IAuthStatePersisted } from '../../types'

type ReturnMigrationType = (state: IAuthStatePersisted) => IAuthStatePersisted

export const authMigrations: Record<string, ReturnMigrationType> = {
  1: state => ({
    ...state,
    data: {
      ...state.data,
      user: null,
      isAuth: false,
      session: null,
    },
  }),
  2: state => ({
    ...state,
    data: {
      ...state.data,
      user: null,
      isAuth: false,
      session: null,
    },
  }),
  3: state => ({
    ...state,
    data: {
      ...state.data,
      user: null,
      isAuth: false,
      session: null,
      agentLinks: [],
    },
  }),
  4: state => ({
    ...state,
    data: {
      ...state.data,
      user: null,
      isAuth: false,
      session: null,
      agentLinks: [],
      agentLinksLastLoadTime: null,
    },
  }),
  5: state => ({
    ...state,
    data: {
      ...state.data,
      user: null,
      isAuth: false,
      session: null,
      agentSocialLinks: [],
    },
  }),
}
